import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plus-info-inner-wrapper bg-white border-1 border position-relative my-0 my-sm-5" }
const _hoisted_2 = { class: "d-flex justify-content-between title-container py-3" }



// Components
import CloseButton from "@/vue/common/clsBtnV2.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentConditionPopup',
  emits: ["close"],
  setup(__props, { emit: __emit }) {

const emit = __emit; 

const handleClick = (): void => {
    emit("close")
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title"),
      _createVNode(CloseButton, { onClick: handleClick })
    ]),
    _renderSlot(_ctx.$slots, "content")
  ]))
}
}

})